import { TrackShipmentResponseSchema, type TrackShipmentResponse } from "@/schemas/ship";

export async function fetchTrackingData(
  shipmentId: string,
  signal?: AbortSignal,
): Promise<TrackShipmentResponse> {
  const url = `/api/tracking?shipmentId=${encodeURIComponent(shipmentId)}`;
  const response = await fetch(url, { signal });
  if (!response.ok) {
    throw new Error(`Failed to fetch tracking data (${response.status})`);
  }

  const data = await response.json();
  return TrackShipmentResponseSchema.parse(data);
}
